/**
 * Picks v2 or v1 of the Captions Generate page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import CaptionsSessionsListPage   from './CaptionsSessionsListPage';
import CaptionsSessionsListPageV2 from './CaptionsSessionsListPageV2';

export default function CaptionsSessionsListPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? CaptionsSessionsListPageV2 : CaptionsSessionsListPage;
  return <Component {...props} />;
}
